import MaterialManagement from './MaterialManagement.vue'
export default MaterialManagement


// WEBPACK FOOTER //
// ./src/pages/MaterialManagement/index.js